// The epoch the shared builder-status store (hooks/useBuilderStatus) keys
// its freshness on. It lives apart from the store so services/api.js can
// open a new epoch after every builder / pitch / study write without
// importing the store (which imports api.js): review 2026-09-27 on #2394
// found that a filing recorded on the patent page, or a deck written on the
// pitch page, left the sidebar's Start here where it was for the rest of the
// session and the home reading up to a minute of pre-write path.
//
// Every invalidate opens a new epoch; a request remembers the epoch it began
// in, and a plain read joins the request in flight, or takes the cache, only
// when that began in the CURRENT epoch. A sequence, not the clock: two things
// in one millisecond have no order on a clock, and they do here. Invalidates
// within one synchronous turn (the home's and the rail's handlers of one
// progress event) open ONE epoch, so the second reader joins the first's
// request.

const state = { epoch: 0, invalidating: false };

// Dispatched once per epoch so the rail (mounted for the whole session)
// re-reads after a write on a step page; the home's mount read is fresh on
// its own. Review 2026-09-27: the epoch alone only made the NEXT read fresh,
// and nothing scheduled one until the student visited /builder.
export const BUILDER_STATUS_INVALIDATED = 'builder-status-invalidated';

export function currentEpoch() {
    return state.epoch;
}

/** Something wrote: the cache and any request that began before it are stale. */
export function invalidateBuilderStatus() {
    if (state.invalidating) return;
    state.invalidating = true;
    state.epoch += 1;
    Promise.resolve().then(() => { state.invalidating = false; });
    if (typeof window !== 'undefined') window.dispatchEvent(new Event(BUILDER_STATUS_INVALIDATED));
}

/** Tests only. */
export function _resetBuilderStatusEpoch() {
    state.epoch = 0;
    state.invalidating = false;
}
